import axios from "axios"
import {getStationCode} from "../../network/NetworkUtil";
import {convertEpochMillisToLocalDateTime} from "../../util/Util";
import {
    logOperationalMetric,
    MetricType,
    PICK_TAB_METRIC_KEY,
    RSWS_DWP_METADATA_METRIC,
    RSWS_DWP_UPLOAD_METRIC
} from "../../util/MetricUtil";
import {TIMEOUTS} from "../../util/Constants";
import {Logger} from "../../util/Logger";
import {getAPIGatewayDataFromParent, getUserLoginFromParent} from "../../handler/ParentDataHandler";

/** Upload DWP File **/
export function uploadDWPFile(data) {
    uploadDWPFileUtil(data)
}

/** Fetch DWP File Details **/
export function getDWPInfo(dispatcher, baseUrl, stationConfig) {
    getDWPFileInfoFromRSWS(dispatcher, baseUrl, stationConfig)
}

async function getuserDetails() {
    const response = await  getUserLoginFromParent();
    return response.name;
}

async function uploadDWPFileUtil(data) {
    const {dispatcher, baseUrl, file, alertDispatch, filterDispatcher, xptNodes, capability, routeDispatcher, stationConfig} = data;
    const startTime = Date.now();
    const stationCode = getStationCode();
    try {
        const username = await getuserDetails();
        const formData = new FormData();
        formData.append("file", file, file.name)
        const config = {
            headers: {"Content-Type": "multipart/form-data"}
        }
        const api = axios.create({
            baseURL: baseUrl,
            timeout: TIMEOUTS.RSWS_DWP_UPLOAD_API_TIMEOUT
        });
        var response;
        if (stationConfig && stationConfig.authEnabled) {
            const fileContent = await file.arrayBuffer();
            const fileContentBase64 = btoa(new Uint8Array(fileContent).reduce(function (data, byte) {
                return data + String.fromCharCode(byte);
            }, ''));
            const requestBody = {
                fileName: file.name,
                fileContent: fileContentBase64
            };

            const requestPayload = {
                resourcePath: "/apigw/station/" + stationCode + "/uploadRoutes",
                httpMethod: "post",
                processName: "routeStaging",
                requestBody: requestBody
            }
            response = await getAPIGatewayDataFromParent(requestPayload);
        } else {
            response = await api.post("/rsws/station/" + stationCode + "/uploadRoutes", formData, config);
        }
        Logger.info("File Uploaded for : " + stationCode + " by user : " + username + " file name is : " + file.name);
        if (response.status === 200) {
            logOperationalMetric(startTime, stationCode, PICK_TAB_METRIC_KEY, RSWS_DWP_UPLOAD_METRIC, MetricType.SUCCESS);
            alertDispatch({
                type: "SHOW_NOTIFICATION",
                data: {
                    alert: {title: "Upload Success", type: "success"}
                }
            });
            dispatcher({
                type: 'LOAD_DWP_INFO', data: {
                    baseUrl: baseUrl,
                    dispatcher: dispatcher,
                    stationConfig: stationConfig
                }
            });
            routeDispatcher({
                type: 'REFRESH_VIEW',
                data: {
                    dispatcher: routeDispatcher,
                    filterDispatcher: filterDispatcher,
                    baseUrl: baseUrl,
                    capability: capability,
                    xptNodes: xptNodes,
                    stationConfig: stationConfig
                }
            });
            return;
        } else {
            var error = {
                response : response
            }
            logOperationalMetric(startTime, stationCode, PICK_TAB_METRIC_KEY, RSWS_DWP_UPLOAD_METRIC, MetricType.FAILED, error);
        }
    } catch (error) {
        Logger.error("Exception in DwpNetworkAPI.uploadDWPFileUtil", error);
        logOperationalMetric(startTime, stationCode, PICK_TAB_METRIC_KEY, RSWS_DWP_UPLOAD_METRIC, MetricType.FAILED, error);
    }
    finally {
        dispatcher({
            type: 'HIDE_LOADER'
        });
    }
    alertDispatch({
        type: "SHOW_NOTIFICATION",
        data: {
            alert: {title: "Upload Failed", type: "error"}
        }
    });
}

async function getDWPFileInfoFromRSWS(dispatcher, baseUrl, stationConfig) {
    const startTime = Date.now();
    const stationCode = getStationCode();
    try {
        const api = axios.create({
            baseURL: baseUrl,
            timeout: TIMEOUTS.RSWS_DEFAULT_API_TIMEOUT
        });
        var response;
        if (stationConfig && stationConfig.authEnabled) {
            const requestPayload = {
                resourcePath: "/apigw/station/" + stationCode + "/dwpMetadata",
                httpMethod: "get",
                processName: "routeStaging"
            }
            response = await getAPIGatewayDataFromParent(requestPayload);
        } else {
            response = await api.get("/rsws/station/" + stationCode + "/dwpMetadata");
        }
        if (response && response.status === 200) {
            const output = response.data;
            logOperationalMetric(startTime, stationCode, PICK_TAB_METRIC_KEY, RSWS_DWP_METADATA_METRIC, MetricType.SUCCESS);
            dispatcher({type: "RECEIVE_DWP_INFO", data: convertDWPInfoResponse(output)});
        } else {
            var error = {
                response : response
            }
            Logger.error("Exception in DwpNetworkAPI.getDWPFileInfoFromRSWS" , error);
            logOperationalMetric(startTime, stationCode, PICK_TAB_METRIC_KEY, RSWS_DWP_METADATA_METRIC, MetricType.FAILED, error);
        }
    } catch (error) {
        Logger.error("Exception in DwpNetworkAPI.getDWPFileInfoFromRSWS", error);
        logOperationalMetric(startTime, stationCode, PICK_TAB_METRIC_KEY, RSWS_DWP_METADATA_METRIC, MetricType.FAILED, error);
    }
}

function convertDWPInfoResponse(response) {
    return response.filename ? {
        fileName: response.filename,
        creationTime: convertEpochMillisToLocalDateTime(response.creationTime),
        uploadSource: response.uploadSource,
        pendingPlanFinalization: response.pendingPlanFinalization
    } : { pendingPlanFinalization: response.pendingPlanFinalization };
}



// WEBPACK FOOTER //
// ./src/components/fileupload/network/DwpNetworkAPI.js